import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule } from '@angular/material';
import { ButtonModule } from '../../views/common/button/button.module';
import { CommonSectionsModule } from '../../views/common/common-sections.module';
import { OtpVerifyPopupComponent } from './otp-verify-popup/otp-verify-popup.component';
import { UserDetailsComponent } from './user-details.component';
import { UserDetailsRoutingModule } from './user-details-routing.module';
import { CibilService } from '../../service/cibil/cibil.service';
import { LivelihoodInformationService } from '../../service/livelihood-information.service';
import { TermsAndConditionsCibilPopupComponent } from './consent-popups/termsAndConditions/termsAndConditions.component';
import { AlternativeMobilePopupComponent } from './alternative-mobile-popup/alternative-mobile-popup.component';
import { EmailVerifyPopupComponent } from './email-verify-popup/email-verify-popup.component';

@NgModule({
    declarations: [
        UserDetailsComponent,
        OtpVerifyPopupComponent,
        TermsAndConditionsCibilPopupComponent,
        AlternativeMobilePopupComponent,
        EmailVerifyPopupComponent
    ],
    imports: [
        UserDetailsRoutingModule,
        CommonModule,
        CommonSectionsModule,
        FormsModule,
        ButtonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSelectModule,
        MatIconModule,
        MatDatepickerModule
    ],
    providers: [CibilService, LivelihoodInformationService]
})
export class UserDetailsModule {
}
